import PropTypes from 'prop-types';

import ClassicIcon from 'components/ClassicIcon';
import SummaryItem from '../SummaryItem';
import MainText from '../MainText';
import SubText from '../SubText';

const RoomAndOfferInfo = ({ roomType, offer, isClassicOffer = false }) => (
  <SummaryItem icon="hotel" label="Room">
    <MainText>1x {roomType}</MainText>
    <SubText>
      {isClassicOffer && <ClassicIcon />}
      {offer}
    </SubText>
  </SummaryItem>
);

RoomAndOfferInfo.propTypes = {
  roomType: PropTypes.string.isRequired,
  offer: PropTypes.string.isRequired,
  isClassicOffer: PropTypes.bool,
};

export default RoomAndOfferInfo;
